import React, { useEffect, useMemo } from "react";
import { Stack, Typography } from "@mui/material";

import { HubHookFormSelect } from "../HubHookFormSelect";
import { useGetCustomerAddresses } from "../../hooks";

const RenderComponent = ({ id, label }) => {
  return (
    <Stack>
      {label?.split(",")?.map((a) => (
        <Typography variant="caption" lineHeight="12px">
          {a}
        </Typography>
      ))}
    </Stack>
  );
};

export const HubHookFormCustomerAddress = ({
  name = "addressId",
  label = "Address",
  defaultValue,
  hideLabel = false,
  disabled = false,
  customerId,
  rendered = false,
  CustomRenderComponent,
  CustomRenderValue = RenderComponent,
  useDefault = false,
  ...rest
}) => {
  const { data, isLoading, refetch } = useGetCustomerAddresses(customerId);
  const options = useMemo(() => data || [], [data]);

  useEffect(() => {
    customerId && refetch();
  }, [customerId]);

  const defaultProps = {
    name,
    defaultValue: useDefault ? defaultValue || options[0]?.id : null,
    options,
    ...(rendered && {
      ...(CustomRenderComponent
        ? { RenderComponent: CustomRenderComponent }
        : {}),
      renderValue: (value) => {
        const address = options?.find(({ id }) => id === value);
        return !!address && <CustomRenderValue {...address} />;
      },
    }),
  };

  return (
    <HubHookFormSelect
      disableHelperText
      useDefault={useDefault}
      disabled={isLoading || disabled}
      {...(!hideLabel ? { label } : {})}
      {...defaultProps}
      {...rest}
    />
  );
};

export default HubHookFormCustomerAddress;
